/*!
 * iE Full Throttle Fall 2026 page runtime (ftl-runtime.js)
 * Renders the FTL page sections and makes their buttons, toggles, chooser,
 * power chart, audio and episode player work. No dependencies.
 * You should not need to edit this file. Page content lives in the
 * sections/ftl-*.liquid files; links and late items live in each section's
 * theme-editor settings.
 */
(function () {
  'use strict';
  if (window.FTL && window.FTL.__ready) return;
  var FTL = window.FTL = window.FTL || {};
  FTL.__ready = true;
  FTL.defs = FTL.defs || {};
  var uid = 0;

  /* ---------- Component base (same shape as the design tool's DCLogic) ---------- */
  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (patch, cb) {
    var inst = this;
    if (!inst.__prevState) inst.__prevState = inst.state;
    var p = typeof patch === 'function' ? patch(inst.state, inst.props) : patch;
    if (p) inst.state = Object.assign({}, inst.state, p);
    if (cb) (inst.__cbs = inst.__cbs || []).push(cb);
    schedule(inst);
  };
  DCLogic.prototype.forceUpdate = function (cb) {
    if (!this.__prevState) this.__prevState = this.state;
    if (cb) (this.__cbs = this.__cbs || []).push(cb);
    schedule(this);
  };
  FTL.DCLogic = DCLogic;

  function schedule(inst) {
    if (!inst.__mounted || inst.__queued) return;
    inst.__queued = true;
    Promise.resolve().then(function () {
      inst.__queued = false;
      var ps = inst.__prevState || inst.state, pp = inst.__prevProps || inst.props;
      inst.__prevState = null; inst.__prevProps = null;
      render(inst);
      if (inst.componentDidUpdate) { try { inst.componentDidUpdate(pp, ps); } catch (e) { console.error(e); } }
      var cbs = inst.__cbs || []; inst.__cbs = null;
      cbs.forEach(function (f) { try { f(); } catch (e) { console.error(e); } });
    });
  }

  /* ---------- Template compile + render to HTML string ---------- */
  var VOID = { area: 1, base: 1, br: 1, col: 1, embed: 1, hr: 1, img: 1, input: 1, link: 1, meta: 1, source: 1, track: 1, wbr: 1 };
  var BOOL = { controls: 1, disabled: 1, hidden: 1, checked: 1, autoplay: 1, muted: 1, loop: 1, playsinline: 1, open: 1, selected: 1, readonly: 1, required: 1, multiple: 1, novalidate: 1, inert: 1 };
  var HOLE = /\{\{\s*([^}]+?)\s*\}\}/g, WHOLE = /^\s*\{\{\s*([^}]+?)\s*\}\}\s*$/;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function lookup(path, scope) {
    if (path === 'true') return true; if (path === 'false') return false;
    if (path === 'null') return null; if (path === 'undefined') return undefined;
    if (/^-?\d+(\.\d+)?$/.test(path)) return parseFloat(path);
    var q = path.match(/^(['"])(.*)\1$/); if (q) return q[2];
    var parts = path.split('.'), v;
    for (var i = scope.length - 1; i >= 0; i--) { if (scope[i] && parts[0] in scope[i]) { v = scope[i][parts[0]]; break; } }
    for (var k = 1; k < parts.length; k++) { if (v == null) return undefined; v = v[parts[k]]; }
    return v;
  }
  function textOf(v) { return (v === null || v === undefined || v === false || v === true) ? '' : String(v); }
  function interp(str, scope) { return str.replace(HOLE, function (_, p) { return textOf(lookup(p, scope)); }); }

  function compile(html) {
    var t = document.createElement('template');
    t.innerHTML = html.replace(/\/_blob\/([0-9a-f]{32})/g, function (_, id) { return FTL.file(id); });
    return t.content;
  }

  function renderNodes(nodes, scope, ctx, out) {
    for (var i = 0; i < nodes.length; i++) renderNode(nodes[i], scope, ctx, out);
  }
  function renderNode(n, scope, ctx, out) {
    if (n.nodeType === 3) { out.push(esc(interp(n.data, scope)).replace(/&quot;/g, '"')); return; }
    if (n.nodeType !== 1) return;
    var tag = n.localName;
    var kids = (tag === 'template' ? n.content : n).childNodes;
    if (tag === 'sc-if') {
      var m = WHOLE.exec(n.getAttribute('value') || '');
      if (m && lookup(m[1], scope)) renderNodes(kids, scope, ctx, out);
      return;
    }
    if (tag === 'sc-for') {
      var lm = WHOLE.exec(n.getAttribute('list') || '');
      var list = lm ? lookup(lm[1], scope) : null, as = n.getAttribute('as') || 'item';
      if (list && list.length) for (var j = 0; j < list.length; j++) {
        var s = {}; s[as] = list[j]; s.$index = j;
        renderNodes(kids, scope.concat([s]), ctx, out);
      }
      return;
    }
    if (tag === 'helmet') return;
    if (tag === 'dc-import') {
      var props = {}, name = n.getAttribute('name');
      for (var a = 0; a < n.attributes.length; a++) {
        var at = n.attributes[a];
        if (at.name === 'name' || at.name.indexOf('hint-') === 0) continue;
        var key = at.name.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
        var wm = WHOLE.exec(at.value);
        props[key] = wm ? lookup(wm[1], scope) : interp(at.value, scope);
      }
      var slot = ctx.imports.length;
      ctx.imports.push({ name: name, props: props });
      out.push('<div data-dc-host="' + slot + '" data-dc-name="' + esc(name) + '" style="display:contents"></div>');
      return;
    }
    var attrs = '', on = [];
    for (var b = 0; b < n.attributes.length; b++) {
      var att = n.attributes[b], an = att.name, av = att.value;
      if (an.indexOf('hint-') === 0) continue;
      var whole = WHOLE.exec(av);
      if (whole) {
        var v = lookup(whole[1], scope);
        if (an === 'ref') { if (typeof v === 'function') { attrs += ' data-dc-ref="' + ctx.reg(v) + '"'; } continue; }
        if (an.length > 2 && an.slice(0, 2) === 'on') { if (typeof v === 'function') on.push(an.slice(2).toLowerCase() + ':' + ctx.reg(v)); continue; }
        if (typeof v === 'function') continue;
        if (v === null || v === undefined) continue;
        if (v === false) { if (an.indexOf('aria-') === 0 || an.indexOf('data-') === 0) attrs += ' ' + an + '="false"'; continue; }
        if (v === true) { attrs += BOOL[an] ? ' ' + an : ' ' + an + '="true"'; continue; }
        attrs += ' ' + an + '="' + esc(v) + '"';
      } else if (av.indexOf('{{') >= 0) {
        attrs += ' ' + an + '="' + esc(interp(av, scope)) + '"';
      } else {
        attrs += ' ' + an + (av === '' && BOOL[an] ? '' : '="' + esc(av) + '"');
      }
    }
    if (on.length) attrs += ' data-dc-on="' + on.join(' ') + '"';
    out.push('<' + tag + attrs + '>');
    if (VOID[tag]) return;
    if (tag === 'style' || tag === 'script') { out.push(n.textContent); }
    else renderNodes(kids, scope, ctx, out);
    out.push('</' + tag + '>');
  }

  /* ---------- Minimal DOM morph (keeps playing video/audio and child components alive) ---------- */
  function sameNode(a, b) {
    if (a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== 1) return true;
    if (a.localName !== b.localName) return false;
    if ((a.id || b.id) && a.id !== b.id) return false;
    var ah = a.getAttribute('data-dc-host'), bh = b.getAttribute('data-dc-host');
    return ah === bh;
  }
  function syncAttrs(from, to) {
    var i, a;
    for (i = from.attributes.length - 1; i >= 0; i--) { a = from.attributes[i]; if (!to.hasAttribute(a.name)) from.removeAttribute(a.name); }
    for (i = 0; i < to.attributes.length; i++) { a = to.attributes[i]; if (from.getAttribute(a.name) !== a.value) from.setAttribute(a.name, a.value); }
    if (from.localName === 'input' || from.localName === 'textarea') {
      var tv = to.getAttribute('value'); if (tv !== null && from.value !== tv) from.value = tv;
      if (from.type === 'checkbox' || from.type === 'radio') from.checked = to.hasAttribute('checked');
    }
  }
  function morphChildren(from, to) {
    var f = from.firstChild, t = to.firstChild;
    while (t) {
      while (f && f.nodeType === 1 && f.hasAttribute('data-ftl-keep')) f = f.nextSibling;
      var tNext = t.nextSibling;
      if (!f) { from.appendChild(t); t = tNext; continue; }
      if (sameNode(f, t)) { morphNode(f, t); f = f.nextSibling; t = tNext; continue; }
      var fNext = f.nextSibling;
      if (fNext && sameNode(fNext, t) && !(tNext && sameNode(f, tNext))) { from.removeChild(f); f = fNext; continue; }
      if (tNext && sameNode(f, tNext)) { from.insertBefore(t, f); t = tNext; continue; }
      from.replaceChild(t, f); f = t.nextSibling; t = tNext;
    }
    while (f) { var n = f.nextSibling; if (!(f.nodeType === 1 && f.hasAttribute('data-ftl-keep'))) from.removeChild(f); f = n; }
  }
  function morphNode(f, t) {
    if (f.nodeType !== 1) { if (f.nodeValue !== t.nodeValue) f.nodeValue = t.nodeValue; return; }
    syncAttrs(f, t);
    if (f.hasAttribute('data-dc-host')) return; // child component owns its content
    morphChildren(f, t);
  }

  /* ---------- Events and refs ---------- */
  var bound = new WeakMap();
  function bindEvents(root, inst) {
    var els = root.querySelectorAll('[data-dc-on]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var have = bound.get(el) || {};
      el.getAttribute('data-dc-on').split(' ').forEach(function (pair) {
        var type = pair.split(':')[0];
        if (have[type]) return;
        have[type] = true;
        el.addEventListener(type, onEvent);
      });
      bound.set(el, have);
    }
  }
  function onEvent(e) {
    var el = e.currentTarget, spec = el.getAttribute('data-dc-on') || '';
    var parts = spec.split(' ');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':');
      if (kv[0] === e.type) { var fn = handlers[kv[1]]; if (fn) { try { fn(e); } catch (err) { console.error(err); } } }
    }
  }
  var handlers = {};

  /* ---------- Mount / render ---------- */
  function render(inst) {
    var vals;
    try { vals = inst.renderVals ? inst.renderVals() || {} : {}; } catch (e) { console.error(e); vals = {}; }
    var cfg = FTL.cfg || {};
    if (!('cfg' in vals)) vals.cfg = cfg;
    if (FTL.decorate) FTL.decorate(inst, vals, cfg);
    // drop this instance's old handlers
    (inst.__hk || []).forEach(function (k) { delete handlers[k]; });
    inst.__hk = [];
    var ctx = {
      imports: [],
      reg: function (fn) { var k = inst.__id + '_' + inst.__hk.length; inst.__hk.push(k); handlers[k] = fn; return k; }
    };
    var out = [];
    renderNodes(inst.__tpl.childNodes, [vals], ctx, out);
    var tmp = document.createElement('template');
    tmp.innerHTML = out.join('');
    morphChildren(inst.__root, tmp.content);
    // children
    var hosts = inst.__root.querySelectorAll('[data-dc-host]');
    inst.__children = inst.__children || {};
    for (var i = 0; i < hosts.length; i++) {
      var h = hosts[i];
      var outer = h.parentElement && h.parentElement.closest('[data-dc-host]');
      if (outer && inst.__root.contains(outer)) continue;
      var slot = h.getAttribute('data-dc-host'), imp = ctx.imports[+slot];
      if (!imp) continue;
      var child = inst.__children[slot];
      if (!child || child.__root !== h) {
        child = mount(imp.name, h, imp.props);
        inst.__children[slot] = child;
      } else if (child && shallowDiff(child.props, imp.props)) {
        child.__prevProps = child.props; child.props = imp.props; child.forceUpdate();
      }
    }
    if (FTL.after) { try { FTL.after(inst.__root, FTL.cfg || {}); } catch (e) { console.error(e); } }
    bindEvents(inst.__root, inst);
    var refs = inst.__root.querySelectorAll('[data-dc-ref]');
    for (var r = 0; r < refs.length; r++) { var fn = handlers[refs[r].getAttribute('data-dc-ref')]; if (fn) { try { fn(refs[r]); } catch (e) { console.error(e); } } }
  }
  function shallowDiff(a, b) {
    var k; for (k in a) if (a[k] !== b[k]) return true; for (k in b) if (!(k in a)) return true; return false;
  }

  function mount(name, rootEl, props) {
    var def = FTL.defs[name];
    if (!def) { console.warn('[FTL] missing component', name); return null; }
    if (!def.Cls) def.Cls = def.factory(DCLogic);
    if (!def.tpl) def.tpl = compile(def.html);
    var inst;
    try { inst = new def.Cls(props || {}); } catch (e) { console.error(e); return null; }
    if (!inst.state) inst.state = {};
    inst.__id = 'c' + (++uid);
    inst.__tpl = def.tpl;
    inst.__root = rootEl;
    inst.__hostEl = rootEl;
    render(inst);
    inst.__mounted = true;
    if (inst.componentDidMount) { try { inst.componentDidMount(); } catch (e) { console.error(e); } }
    return inst;
  }
  FTL.mount = mount;


  /* ---------- FTL page features: files, episode player, media slots, lightbox ---------- */
  FTL.file = function (id) { var f = (FTL.cfg && FTL.cfg.files) || {}; return f[id] || ('/_blob/' + id); };

  FTL.video = function (url) {
    url = (url || '').trim();
    if (!url) return null;
    var m = url.match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([\w-]{11})/);
    if (m) return { kind: 'youtube', id: m[1] };
    m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return { kind: 'vimeo', id: m[1] };
    return { kind: 'file', src: url };
  };
  function embedSrc(v, t, autoplay) {
    t = Math.floor(t || 0);
    if (v.kind === 'youtube') return 'https://www.youtube-nocookie.com/embed/' + v.id + '?rel=0&playsinline=1&modestbranding=1' + (autoplay ? '&autoplay=1' : '') + (t ? '&start=' + t : '');
    if (v.kind === 'vimeo') return 'https://player.vimeo.com/video/' + v.id + '?' + (autoplay ? 'autoplay=1' : '') + (t ? '#t=' + t + 's' : '');
    return v.src;
  }

  // Episode hero: decide what the player shows, from the section settings
  var responsive = [];
  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () { responsive.forEach(function (i) { if (i.__mounted) i.forceUpdate(); }); }, 120);
  });
  FTL.decorate = function (inst, v, cfg) {
    // CarPlay demo: shrink to fit narrow containers (it is drawn at 820px wide)
    if ('outerW' in v && 'screenH' in v && 'scale' in v) {
      if (!inst.__responsive) { inst.__responsive = true; responsive.push(inst); }
      var host = inst.__root, par = host && host.parentElement;
      if (par) {
        var cs = getComputedStyle(par);
        var avail = par.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
        if (avail > 0) {
          var sc = Math.min(parseFloat(v.scale) || 1, avail / 820);
          v.scale = sc; v.outerW = Math.round(820 * sc) + 'px'; v.screenH = Math.round(452 * sc) + 'px';
        }
      }
    }
    if (!('epOpen' in v)) return;
    var ep = cfg.ep || {}, vid = FTL.video(ep.url), kind = vid ? vid.kind : '';
    v.epShowVid = kind === 'file';
    v.epShowYT = (kind === 'youtube' || kind === 'vimeo') && !!v.epOpen;
    v.epShowImg = !v.epShowVid && !v.epShowYT;
    v.epSoon = !!v.epOpen && !kind;
    v.epYT = v.epShowYT ? embedSrc(vid, inst.state && inst.state.epT, true) : '';
    if (cfg.ep) cfg.ep.file = kind === 'file' ? vid.src : '';
  };
  // Episode chapter start times from settings ("0:00, 2:15, 4:40")
  FTL.chapters = function (chs) {
    var t = ((FTL.cfg || {}).ep || {}).times;
    if (typeof t === 'string') {
      t = t.split(/[,;\n]+/).map(function (x) {
        x = x.trim(); if (!x) return NaN;
        return x.split(':').reduce(function (acc, n) { return acc * 60 + parseFloat(n); }, 0);
      });
    }
    if (!t || !t.length) return;
    for (var i = 0; i < chs.length && i < t.length; i++) if (typeof t[i] === 'number' && !isNaN(t[i])) chs[i][1] = t[i];
  };

  // Media slots (films and episode thumbnails): poster image + optional video from settings
  FTL.after = function (root, cfg) {
    var labels = root.querySelectorAll('[data-ftl-ph]');
    for (var i = 0; i < labels.length; i++) {
      var lbl = labels[i], key = lbl.getAttribute('data-ftl-ph');
      var slot = lbl.closest('.media') || lbl.parentElement;
      if (!slot) continue;
      var s = (cfg.slots || {})[key] || {};
      slot.setAttribute('data-ftl-slot', key);
      if (getComputedStyle(slot).position === 'static') slot.style.position = 'relative';
      slot.style.overflow = 'hidden';
      var img = slot.querySelector(':scope > img[data-ftl-keep]');
      var src = s.img || s.fallback || '';
      var soon = slot.querySelector(':scope > .ftl-slot-soon');
      if (!src && !s.video && s.soon) {
        if (!soon) { soon = document.createElement('span'); soon.className = 'ftl-slot-soon'; soon.setAttribute('data-ftl-keep', ''); slot.appendChild(soon); }
        soon.textContent = s.soon;
      } else if (soon) soon.remove();
      if (src) {
        if (!img) {
          img = document.createElement('img');
          img.setAttribute('data-ftl-keep', '');
          img.alt = s.alt || '';
          img.loading = 'lazy';
          img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;z-index:0';
          slot.insertBefore(img, slot.firstChild);
        }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      } else if (img) img.remove();
      var play = slot.querySelector('.play');
      if (!play) { var prev = lbl.previousElementSibling; if (prev && prev.querySelector('svg')) play = prev; }
      if (play) { play.style.display = s.video ? '' : 'none'; if (getComputedStyle(play).position === 'static') play.style.position = 'relative'; play.style.zIndex = '1'; }
      if (s.video) { slot.setAttribute('data-ftl-play', key); slot.style.cursor = 'pointer'; slot.setAttribute('tabindex', '0'); slot.setAttribute('role', 'button'); }
    }
  };

  // Lightbox player for media slots
  function openLightbox(url, title) {
    var v = FTL.video(url); if (!v) return;
    var box = document.createElement('div');
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', title || 'Video');
    box.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.88);display:flex;align-items:center;justify-content:center;padding:16px';
    var frame = document.createElement('div');
    frame.style.cssText = 'position:relative;width:min(100%,1200px);aspect-ratio:16/9;background:#000;border-radius:16px;overflow:hidden';
    var media;
    if (v.kind === 'file') { media = document.createElement('video'); media.src = v.src; media.controls = true; media.autoplay = true; media.playsInline = true; }
    else { media = document.createElement('iframe'); media.src = embedSrc(v, 0, true); media.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; media.setAttribute('allowfullscreen', ''); media.style.border = '0'; }
    media.style.cssText += ';width:100%;height:100%;display:block';
    var close = document.createElement('button');
    close.type = 'button'; close.setAttribute('aria-label', 'Close video'); close.textContent = '×';
    close.style.cssText = 'position:absolute;top:16px;right:16px;width:48px;height:48px;border-radius:999px;border:0;background:#F5F5F7;color:#0B0B0C;font:400 28px/48px system-ui;cursor:pointer';
    frame.appendChild(media); box.appendChild(frame); box.appendChild(close);
    var last = document.activeElement;
    function done() { document.removeEventListener('keydown', onKey); box.remove(); document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); }
    function onKey(e) { if (e.key === 'Escape') done(); }
    close.addEventListener('click', done);
    box.addEventListener('click', function (e) { if (e.target === box) done(); });
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(box);
    close.focus();
  }
  FTL.openLightbox = openLightbox;
  function wireSlots(sr) {
    function go(e) {
      var el = e.target.closest && e.target.closest('[data-ftl-play]');
      if (!el) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      var s = ((FTL.cfg || {}).slots || {})[el.getAttribute('data-ftl-play')] || {};
      if (!s.video) return;
      e.preventDefault();
      openLightbox(s.video, s.alt);
    }
    sr.addEventListener('click', go);
    sr.addEventListener('keydown', go);
  }

  /* ---------- Page wiring: shadow roots, view switching, in-page links ---------- */
  function shadowOf(host) {
    if (host.shadowRoot) return host.shadowRoot;
    var t = host.querySelector(':scope > template[shadowrootmode], :scope > template[shadowroot]');
    if (!t) return null;
    var sr = host.attachShadow({ mode: 'open' });
    sr.appendChild(t.content.cloneNode(true));
    t.remove();
    return sr;
  }
  function headerOffset() {
    var h = document.querySelector('header, .header-wrapper, #shopify-section-header, [id*="header"]');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position === 'sticky' || cs.position === 'fixed') return h.getBoundingClientRect().height;
    var p = h.closest('.shopify-section'); if (p) { cs = getComputedStyle(p); if (cs.position === 'sticky' || cs.position === 'fixed') return p.getBoundingClientRect().height; }
    return 0;
  }
  function scrollToEl(el) {
    if (!el) return;
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var top = el.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
  }
  function findIn(sr, id) {
    if (!sr || !id) return null;
    return sr.getElementById ? (sr.getElementById(id) || sr.getElementById(id + '-d')) : null;
  }
  function wireAnchors(sr) {
    sr.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = '';
      if (href.charAt(0) === '#') hash = href.slice(1);
      else {
        try { var u = new URL(href, location.href); if (u.pathname === location.pathname && u.hash) hash = u.hash.slice(1); } catch (err) {}
      }
      if (!hash) { if (href === '#') e.preventDefault(); return; }
      var t = findIn(sr, decodeURIComponent(hash));
      if (!t) return;
      e.preventDefault();
      scrollToEl(t);
      try { history.replaceState(null, '', '#' + hash); } catch (err) {}
    });
  }

  function boot(section) {
    if (section.__ftlBooted) return;
    section.__ftlBooted = true;
    var cfgEl = section.querySelector('script[data-ftl-cfg]');
    if (cfgEl) { try { FTL.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[FTL] settings', e); } }
    var views = Array.prototype.slice.call(section.querySelectorAll('[data-ftl-view]'));
    var mq = window.matchMedia('(max-width: 767.98px)');
    function want(v) { return v.getAttribute('data-ftl-view') === (mq.matches ? 'm' : 'd'); }
    function start(v) {
      if (v.__ftlInst) return;
      var sr = shadowOf(v); if (!sr) return;
      var root = sr.querySelector('.ftl-doc');
      if (!root) return;
      wireAnchors(sr);
      wireSlots(sr);
      v.__ftlInst = mount(v.getAttribute('data-ftl-comp'), root, {});
    }
    views.forEach(function (v) { shadowOf(v); if (want(v)) start(v); });
    var onChange = function () { views.forEach(function (v) { if (want(v)) start(v); }); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
    if (location.hash) {
      setTimeout(function () {
        var v = views.filter(want)[0];
        if (v && v.shadowRoot) scrollToEl(findIn(v.shadowRoot, decodeURIComponent(location.hash.slice(1))));
      }, 250);
    }
  }
  FTL.boot = function () {
    var s = document.querySelectorAll('[data-ftl-section]');
    for (var i = 0; i < s.length; i++) boot(s[i]);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', FTL.boot); else FTL.boot();
  // Shopify theme editor: re-boot a section after its settings change
  document.addEventListener('shopify:section:load', function () { FTL.boot(); });
})();
